import cx from 'classnames';
import { motion } from 'framer-motion';

export default function IntroText({ children, className, ...props }) {
  return (
    <motion.article
      className={cx('mx-auto text-center text-lg font-light text-neutral-600', className)}
      {...props}
    >
      {children}
    </motion.article>
  );
}
